import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';

type Children = {
	id: number;
	name: string;
}

@Injectable({
	providedIn: 'root'
})
export class CategoriesService {

	constructor(
		private http: HttpClient,
		private httpService: HttpService
	) {}

	getChildren(id: number): Promise<Array<Children>> {
		return this.httpService.getPromise<Array<Children>>(
			this.http
				.get<Array<Children>>(`/api/data/categories/${id}/children/`)
				.pipe(
					map((categories: Array<Children>) => categories.map(c => ({
						id: c.id,
						name: c.name
					})))
				)
		);
	}
}